import { toast } from 'sonner';
import { problemText, toApiError, type Api } from '@/shared/api';

/** Holt das PDF mit Auth-Header und startet den Download; ein Fehler sagt, warum. */
export function downloadInvoicePdf(api: Api, id: string, fileName: string) {
  api.invoices
    .downloadPdf(id)
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      // Sofort freigegeben bricht der Download in Firefox und Safari still ab.
      window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
    })
    .catch(async (err: unknown) => {
      const e = await toApiError(err);
      toast.error(problemText(e, 'Das PDF konnte nicht geladen werden.'));
    });
}
